const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.435,
    height: 14.05,
    viewBox: "0 0 13.435 14.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51105",
    d: "M21.042 48.464a.517.517 0 0 0-.686.207.485.485 0 0 0 .213.663 5.474 5.474 0 0 1 3.041 4.878 5.68 5.68 0 0 1-11.354 0 5.469 5.469 0 0 1 3.044-4.876.483.483 0 0 0 .213-.663.516.516 0 0 0-.686-.207 6.449 6.449 0 0 0-3.585 5.75 6.6 6.6 0 0 0 6.693 6.49 6.6 6.6 0 0 0 6.692-6.492 6.451 6.451 0 0 0-3.583-5.75z",
    transform: "translate(-11.215 -46.68)",
    style: {
      fill: "#868687",
      stroke: "#fff",
      strokeWidth: ".05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51106",
    d: "M238.784 7.831V.652a.652.652 0 0 0-1.3 0v7.179a.652.652 0 0 0 1.3 0z",
    transform: "translate(-231.414 .025)",
    style: {
      fill: "#868687",
      stroke: "#fff",
      strokeWidth: ".05px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerButton);
export default __webpack_public_path__ + "static/media/power_button.c4878e22385944165a0bd4cd8879d374.svg";
export { ForwardRef as ReactComponent };